import { RefObject } from 'react'
import { Flex } from '@chakra-ui/react'
import styled from '@emotion/styled'

import { InteractiveBox } from 'components/ui/InteractiveBox'

export const DateTimePickerWrapper = styled(InteractiveBox)<{ disabled?: boolean }>`
  overflow: hidden;

  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};

  * {
    ${({ disabled }) => (disabled ? 'pointer-events: none;' : '')};
  }
`

export const DateTimePickerButtonsWrapper = styled(Flex)(() => ({
  margin: '0 -8px',
  '> *': {
    flex: 1,
    margin: '0 8px',
  },
}))

export const PickersWrapper = styled('div', {
  shouldForwardProp: (prop) => !['pickersContentRef', 'defaultCollapsed', 'isExpanded'].includes(prop.toString()),
})<{
  pickersContentRef: RefObject<HTMLDivElement | null>
  defaultCollapsed?: boolean
  isExpanded: boolean
}>`
  overflow: hidden;
  position: relative;

  transition: max-height 0.25s ease-in;

  max-height: ${({ isExpanded }) => (!isExpanded ? 0 : 'unset')};

  &.collapse {
    &-enter {
      max-height: ${({ pickersContentRef }) => pickersContentRef.current?.scrollHeight || 0}px;

      &-active {
        max-height: 0;
      }

      &-done {
        max-height: 0;
      }
    }

    &-exit {
      max-height: 0;

      &-active {
        max-height: ${({ pickersContentRef }) => pickersContentRef.current?.scrollHeight || 0}px;
      }

      &-done {
        max-height: ${({ pickersContentRef }) => pickersContentRef.current?.scrollHeight || 0}px;
      }
    }
  }
`

export const PickersContent = styled.div`
  position: relative;
  padding-top: 16px;
`
